/** Practice options for solution story form — must match Google Sheet `practices` tab names exactly. */
export const SOLUTION_STORY_PRACTICE_OPTIONS = [
  'AI-native Cloud Platform modernization',
  'AI-native Cloud security & reliability engineering',
  'AI-native Modern business Ops',
  'AI-native Modern Work Ops',
] as const;

export type SolutionStoryPractice = (typeof SOLUTION_STORY_PRACTICE_OPTIONS)[number];
